import React from 'react';
import classnames from 'classnames';
import LoadMoreBtn from './load_more_btn/LoadMoreBtn';
import ReviewItem from './review_item/ReviewItem';
import NewReviewItem from './NewReviewItem';
import './reviews-list.scss';

class ReviewsList extends React.Component {

    static genKey(index, username) {
        return `${index}-${username}`;
    }

    render() {
        const {
            reviews,
            type,
            fetchReviews,
            lastReview,
            showLoadMore,
            pathFinderConfig,
            isDoubleBlindFormat,
            noRanking,
            gigId
        } = this.props;

        return (
            <div>
                <ul className={classnames('review-list', {'no-ranking': noRanking})}>
                    {reviews.reduce((filtered, review, index) => {
                        if (review) {
                            const username = review.get('username') || review.get('rater_username');
                            const key = ReviewsList.genKey(index, username);

                            if (isDoubleBlindFormat) {
                                filtered.push(<NewReviewItem key={key} review={review}/>);
                            }
                            else {
                                filtered.push(<ReviewItem key={key} review={review} gigId={gigId}/>);
                            }
                        }
                        return filtered;
                    }, [])}
                </ul>
                {showLoadMore && <LoadMoreBtn fetchReviews={fetchReviews}
                    type={type}
                    lastReview={lastReview}
                    pathFinderConfig={pathFinderConfig}/>}
            </div>
        );
    }
}

export default ReviewsList;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/ReviewsList.js